import { Injectable } from '@angular/core';
import { Apollo, ApolloBase } from 'apollo-angular';
import { IntegrationProviderEnum, Uuid } from '../../../../../../../graphql';
import { GLOBAL_GRAPHQLGATEWAY_NAME_NO_OVERLAY } from '../../../../../../graphql.module';
import { SyncExternalInvoicePayments } from './mutations/syncExternalInvoicePayments.generated';

@Injectable({ providedIn: 'root' })
export class InvoicingApiService {
    constructor(private apollo: Apollo) {}

    get #gql(): ApolloBase<string> {
        return this.apollo.use(GLOBAL_GRAPHQLGATEWAY_NAME_NO_OVERLAY);
    }

    syncExternalInvoicePayments(jobId: Uuid, provider: IntegrationProviderEnum) {
        return this.#gql.mutate({
            mutation: SyncExternalInvoicePayments,
            variables: {
                input: {
                    jobId,
                    provider,
                },
            },
            fetchPolicy: 'no-cache',
            errorPolicy: 'all',
        });
    }
}
